import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const PenOutlinedSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.5 15.5H4.63933L14.6427 5.49662C15.7858 4.35357 15.7858 2.50033 14.6427 1.35728C13.4997 0.214239 11.6464 0.214239 10.5034 1.35728L0.5 11.3607V15.5ZM11.5839 6.57548L4.05943 14.1H1.9L1.9 11.9406L9.42452 4.41605L11.5839 6.57548ZM12.5739 5.58554L13.6528 4.50667C14.2491 3.91036 14.2491 2.94354 13.6528 2.34723C13.0565 1.75092 12.0896 1.75092 11.4933 2.34723L10.4145 3.4261L12.5739 5.58554Z", fill: "var(--magritte-ui-icon-color)" }) }) }) }));
const PenOutlinedSize16 = hoc(forwardRef(PenOutlinedSize16Component), 'PenOutlinedSize16');

export { PenOutlinedSize16 as default };
//# sourceMappingURL=PenOutlinedSize16.js.map
